module.exports = __webpack_public_path__ + "media/images/front/icon_down_green-4cc1f89ab40e260bb2c412b291cd4154.png";